<template>
  <div>
    <b-overlay
      variant="white"
      :show="submitting"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
    >
      <validation-observer ref="RolesAndPermissionsDetailForm">
        <b-form ref="RolesAndPermissionsDetailFormElement" class="" @submit.prevent="submit">
          <b-row>
            <b-col sm="6" lg="4">
              <b-form-group>
                <div class="d-flex form-group-label">
                  <label for="name">{{ t('Title') }}</label>
                  <span class="text-danger">*</span>
                </div>
                <validation-provider #default="{ errors }" :name="t('Name')" rules="required">
                  <b-form-input
                    id="Name"
                    v-model="values.name"
                    name="name"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="t('Name')"
                    tabindex="3"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col sm="6" lg="4">
              <b-form-group>
                <div class="d-flex form-group-label">
                  <label for="description">{{ t('Description') }}</label>
                  <span class="text-danger">*</span>
                </div>
                <validation-provider
                  #default="{ errors }"
                  :name="t('Description')"
                  rules="required"
                >
                  <b-form-input
                    id="description"
                    v-model="values.description"
                    name="description"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="t('Description')"
                    tabindex="3"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6" lg="4">
              <b-form-group label-for="status" :label="t('Status')">
                <b-form-checkbox v-model="values.status" name="check-button" switch tabindex="10">
                  {{ values.status ? t('Active') : t('Passive') }}
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <b-button
            variant="primary"
            class="mt-1 d-flex align-items-center"
            type="submit"
            tabindex="11"
          >
            {{ submitting ? t('Please Wait') : type === 'new' ? t('Create') : t('Edit') }}
          </b-button>
        </b-form>
      </validation-observer>
    </b-overlay>
  </div>
</template>
<script>
import {
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BFormCheckbox,
  BButton,
  BOverlay
} from 'bootstrap-vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { helper } from '@core/mixins/helper.js';

export default {
  components: {
    BOverlay,
    BButton,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BForm,
    BFormCheckbox,

    ValidationObserver,
    ValidationProvider
  },

  mixins: [helper],

  props: {
    type: {
      type: String,
      default: 'new'
    },
    submitting: {
      type: Boolean,
      default: false
    },
    values: {
      type: Object,
      default() {
        return {
          name: '',
          status: '',
          description: ''
        };
      }
    }
  },
  data() {
    return {
      statusOptions: []
    };
  },

  mounted() {
    this.statusOptions = [
      { value: false, text: this.$t('Passive') },
      { value: true, text: this.$t('Active') }
    ];
  },
  methods: {
    submit() {
      this.$refs.RolesAndPermissionsDetailForm.validate().then(success => {
        if (success) {
          this.$emit('submit', {
            ...this.values
          });
        }
      });
    },
    resetForm() {
      this.$refs.RolesAndPermissionsDetailFormElement.reset();
    }
  },

  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
